module.exports = __webpack_public_path__ + "img/p12.cd78093b.jpg";